import { render, staticRenderFns } from "./tradeflow-list.vue?vue&type=template&id=3f6ae5b4&"
import script from "./tradeflow-list.vue?vue&type=script&lang=js&"
export * from "./tradeflow-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeflow-list.vue"
export default component.exports